import { JobProgressionFlow } from 'jobs/progression/JobProgression'
import React from 'react'

interface RequestDraftReturnTextProps {
  hasDraftReturn: boolean
  isDraftReturnDownloadable?: boolean
  currentProgressionFlow?: JobProgressionFlow
}

export default function RequestDraftReturnText({
  hasDraftReturn,
  isDraftReturnDownloadable,
  currentProgressionFlow,
}: RequestDraftReturnTextProps) {
  if (
    currentProgressionFlow === JobProgressionFlow.OUTSOURCING ||
    currentProgressionFlow === JobProgressionFlow.REVIEW
  ) {
    return 'Request Draft Approval'
  }

  if (!hasDraftReturn) {
    return 'Upload Draft Return'
  }

  return (
    <>
      {isDraftReturnDownloadable
        ? 'Request Draft Approval'
        : 'Verification in progress'}
    </>
  )
}
